import type { HelpFile } from '../../types/help'
import { CreatePartyTestIds } from '../../../testids/CreatePartyTestIds'

export const createPartyHelp: HelpFile = {
  docPage: '/docs/identity/parties',
  texts: {
    [CreatePartyTestIds.cardTitleCreateParty]:
      'Create a new party of the locked type. Required attributes are derived from the type\u2019s attribute definitions and its display-name template.',
    [CreatePartyTestIds.btnCancelCreateParty]: null,
    [CreatePartyTestIds.btnSubmitCreateParty]: null,
  },
}
